import React from 'react';

import Typography from '@material-ui/core/Typography';
import countries from "i18n-iso-countries";
import { parsePhoneNumberFromString } from 'libphonenumber-js'

import "Components/Components.css"
import "./Review_and_Submit.css";
import Garbage from 'Assets/Images/garbage.png'; 

import currencyFormatter from 'currency-formatter';

countries.registerLocale(require("i18n-iso-countries/langs/en.json"));

class ReviewAndSubmit extends React.Component {

    componentDidMount() {
        //get the correct concession id slot, and calculate total prices
        this.calculateCosts();
    }

    getConcessionInfo = () => {
        let concessionInfo = this.props.concessionData.filter(concession => Number(concession.location_id) === this.props.shipLocation );
        return concessionInfo[0];
    }
    
    calculateCosts = () => {
        //update order with each cart item having a "combined_price" field
        const concessionInfo = this.getConcessionInfo();
        let orderList = this.props.order;
        orderList.forEach(orderItem => {
            orderItem.combined_price = Number(orderItem.quantity) * concessionInfo.pretax_price;
        });
        if (concessionInfo.tax_type !== null) {
            //if tax exists
            orderList.forEach(orderItem => orderItem.combined_price *= (1 + concessionInfo.tax_rate/100));
        }
        //update order list
        this.props.updateOrder(orderList);
    }

    getPersonDetails = () => {

        const phoneNumber = parsePhoneNumberFromString(String(this.props.phone));

        return (
            <div>
                <div className="contact-field">
                    <div className="summary-label-field">
                        First Name
                        </div>
                    <div className="money-field">
                        {this.props.firstName}
                    </div>

                    <div className="summary-label-field">
                        Last Name
                        </div>
                    <div className="money-field">
                        {this.props.lastName}
                    </div>

                    <div className="summary-label-field">
                        Email Address
                    </div>
                    <div className="money-field">
                        {this.props.email}
                    </div>

                    <div className="summary-label-field">
                        Phone Number
                    </div>
                    <div className="money-field">
                        {phoneNumber.formatNational()}
                    </div>
                </div>
                <hr />
            </div>
        )
    }

    getOrderDetails = () => {
        return (
            <div>
                {this.props.order.map((order, index) =>
                    <div key={index} className="order-list">
                        <div className="order-label-field">
                            {this.getOrderItem(order)}
                        </div>
                        <div className="money-field">
                            {this.getOrderAmount(order)}
                        </div>
                        <div className="imgContainer">
                            <img src={Garbage} alt="garbage" className = "garbage-icon" onClick={e => this.deleteOrderItem(index)} />
                        </div>
                    </div>
                )}
            </div>
        )
    }

    deleteOrderItem = (index) => {
        let newOrderList = this.props.order;
        newOrderList.splice(index, 1);
        this.props.updateOrder(newOrderList);
        this.forceUpdate();
    }

    getPriceSummary = () => {
        const concessionInfo = this.getConcessionInfo();

        const subTotal = this.props.order.reduce((total, orderItem) => total += orderItem.quantity * concessionInfo.pretax_price, 0);
        const shipping = (this.props.deliveryOption === "outsideStore")? 20 : 0;
        const total = (concessionInfo.tax_type !== null)? (subTotal * (1 + concessionInfo.tax_rate/100)) + shipping : subTotal + shipping;


        return (
            <div>
                <div className="price-field">
                    <div className="summary-label-field">
                        Subtotal:
                        </div>
                    <div className="money-field">
                        {currencyFormatter.format(subTotal, {code: 'USD'})}
                    </div>

                    <div className="summary-label-field">
                        Shipping and Handling:
                    </div>
                    <div className="money-field">
                        {currencyFormatter.format(shipping, {code: 'USD'})}
                    </div>

                    <div className="summary-label-field">
                        <span className="bold-text">Total Price:</span>
                    </div>
                    <div className="money-field">
                        <span className="bold-text">{currencyFormatter.format(total, {code: 'USD'})}</span>
                    </div>
                </div>
            </div>
        )
    }

    getShippingSummary = () => {
        if (this.props.shipCountry !== "") {
            return (
                <div>
                    <div className="shipping-field">
                        <div className="summary-label-field">
                            Country
                        </div>
                        <div className="money-field">
                            {countries.getName(this.props.shipCountry, "en")}
                        </div>

                        <div className="summary-label-field">
                            Province
                        </div>
                        <div className="money-field">
                            {this.props.shipProvinceState}
                        </div>

                        <div className="summary-label-field">
                            City
                        </div>
                        <div className="money-field">
                            {this.props.shipCity}
                        </div>

                        <div className="summary-label-field">
                            Address
                        </div>
                        <div className="money-field">
                            {this.props.shipAddress}
                        </div>

                        <div className="summary-label-field">
                            Postal Code
                        </div>
                        <div className="money-field">
                            {this.props.shipPostalCode}
                        </div>
                    </div>
                    <hr />
                </div>
            )
        } else {
            //if no country then it was a store chosen delivery option
            let locationName = (this.props.allLocations !== undefined && this.props.allLocations !== null && this.props.allLocations.length > 0)
                ? this.props.allLocations.filter(location => location.location_id === this.props.shipLocation)
                : null;
            if (locationName === null) {
                locationName = this.props.shipLocation;
            } else if (locationName.length === 0) {
                locationName = this.props.shipLocation;
            } else {
                //filter workerd
                locationName = locationName[0].location_name;
            }

            return (
                <div>
                    <div className="store-shipping-field">
                        <div className="summary-label-field">
                            Store Location
                        </div>
                        <div className="money-field">
                            {locationName}
                        </div>
                    </div>
                    <hr />
                </div>


            )
        }


    }

    getOrderItem = (order) => {
        //pick 0th index because all locations will have constant info here
        let colour = this.props.concessionData[0].tshirt_colours.filter(colour => colour.colour_id === order.colour);
        colour = colour[0].colour_name;
        let fit = this.props.concessionData[0].tshirt_genders.filter(gender => gender.gender_id === order.fit);
        
        fit = fit[0].gender_name;
        let size = this.props.concessionData[0].tshirt_sizes.filter(size => size.size_id === order.size);
        size = size[0].size_name;

        return `${order.quantity}X ${fit} ${size} ${colour} T-SHIRT`;
    }

    getOrderAmount = (order) => {
        const concessionInfo = this.getConcessionInfo();
        let amount = Number(order.quantity) * concessionInfo.pretax_price;
        return currencyFormatter.format(amount, {code: 'USD'});
    }

    render() {

        return (
            <div className="container">
                <Typography variant="h6" gutterBottom>
                    <div className="section-header">Review and Submit</div>
                </Typography>
                <hr />
                {this.getPersonDetails()}
                <div className="review-container">
                    {this.getOrderDetails()}
                </div>
                <hr />
                {this.getShippingSummary()}
                <div className="price-summary-container">
                    {this.getPriceSummary()}
                </div>
                <div className="no-refunds">
                    Items In Cart Are Not Eligible For Refund
                </div>
            </div>
        )
    }
}

export default ReviewAndSubmit;